import { ProfileSections } from '@/features/profile/components/ProfileSections'
import { ProfileRightPane } from '@/features/profile/components/ProfileRightPane'
import { createFileRoute, useParams } from '@tanstack/react-router'
import { JobApplicationStatusProvider } from '@/shared/contexts'

export const Route = createFileRoute('/_auth/profiles/view/$userID/$jobApplicationID',)({
  component: RouteComponent,
})

function RouteComponent() {
  const { userID, jobApplicationID } = useParams({ from: Route.id })
  const userIDNum = parseInt(userID, 10)
  const jobApplicationIDNum = parseInt(jobApplicationID, 10)

  return (
    <JobApplicationStatusProvider>
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-8">
          <div className="grid grid-cols-12 gap-6">
            {/* Profile Sections - Left Panel */}
            <main className="col-span-12 lg:col-span-8">
              <ProfileSections userID={userIDNum} jobApplicationID={jobApplicationIDNum} />
            </main>
             <aside className="col-span-12 lg:col-span-4 space-y-6">
              {/* Right Panel */}
              <ProfileRightPane userID={userIDNum} jobApplicationID={jobApplicationIDNum} />
             </aside>
          </div>
        </div>
      </div>
    </JobApplicationStatusProvider>
  )
}
